import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ArrowDown = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M11.41 12.293l4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
  </SvgIcon>
);

export default ArrowDown;
